import { useStore } from "vuex";
import { ref } from "vue";
import { getLoginQrcode, loginCheck } from "@/service";
import { ElMessage } from "element-plus";

export default () => {
  const store = useStore();
  const qrcodeImg = ref("");
  const redirectToURL = ref("");
  const isWechat =
    window.navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      window.navigator.userAgent
    );
  console.log("aaa" + isMobile);

  async function doLoginProcess() {
    const { code, qrcode, kuaijie_url } = await getLoginQrcode().then((res) => {
      if (!res.errno) {
        console.log(res);
        return res.data;
      }
      return {};
    });
    qrcodeImg.value = qrcode;
    console.log(kuaijie_url);
    redirectToURL.value = kuaijie_url;
    checkLoop(code);
  }

  let timer = null;
  let checkLoading = ref(false);
  function checkLoop(code) {
    timer = setInterval(() => {
      if (checkLoading.value) {
        console.log("上个请求还没回来，不继续发这个请求");
        return;
      }
      checkLoading.value = true;
      loginCheck(code)
        .then(async (res) => {
          if (res.data.login) {
            ElMessage.success(res.message);
            setTimeout(() => {
              location.reload();
            }, 500);
            clearInterval(timer);
          }
        })
        .finally(() => {
          checkLoading.value = false;
        });
    }, 1500);
  }

  function stopCheckLoop() {
    clearInterval(timer);
  }
  function getHashUrlParam(name) {
    const hashParts = window.location.hash.split("?");
    if (hashParts.length < 2) {
      return null;
    }

    const hashQueries = new URLSearchParams(hashParts[1]);
    return hashQueries.get(name);
  }

  function weChatLogin() {
    const url =
      "/web.php/login/h5?sitecode=" +
      (getHashUrlParam("sitecode") || "ti34") +
      "&tui_id=" +
      (getHashUrlParam("tui_id") || "0") +
      "&tuid=" +
      (getHashUrlParam("tuid") || "0") +
      "&from=" +
      encodeURIComponent(window.location.href);
    location.href = url;
  }

  return {
    qrcodeImg,
    redirectToURL,
    logout() {
      store.dispatch("logout");
    },
    doLoginProcess,
    stopCheckLoop,
    isWechat,
    isMobile,
    weChatLogin,
  };
};
